const MS365BackUpSetIcon = ({ color = '#94A3B8' }: { color?: string }) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H6.70625V6.70625H0V0ZM7.29375 0H14V6.70625H7.29375V0ZM0 7.29375H6.70625V14H0V7.29375ZM7.29375 7.29375H14V14H7.29375V7.29375Z" fill={color} />
  </svg>
);

export default MS365BackUpSetIcon;
